import http from '@/utils/http'
// import convert from '@/utils/model-convert'
// import { FormArgument } from '@/models/ec-setting'

const EC_FIELD_URL = '/rest/es/crmfieldmapping/getByUser'
const EC_FIELD_SELECT = '/rest/es/wystaticfield/listAll'
const POST_EC_FIELD_URL = '/rest/es/crmfieldmapping/post'
const UPDATEEC_FIELD_URL = '/rest/es/crmfieldmapping/updateFieldMapping'
const ITEMS_URL = '/rest/customer/platform/items/all'
const CHANNELS_URL = '/rest/customer/platform/channels/listAll'

export default {
  getEcField ({crmCode}, cb) {
    http.get(EC_FIELD_URL, {params: {crmCode}}).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  getEcFieldSelect (cb) {
    http.get(EC_FIELD_SELECT).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  saveEcField (form, cb) {
    let postData = JSON.stringify(form)
    http.post(POST_EC_FIELD_URL, postData, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  UpdateEcField ({crmCode}, cb) {
    http.get(UPDATEEC_FIELD_URL, {params: {crmCode}}).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  getItem (cb) {
    http.get(ITEMS_URL).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  getChannels (cb) {
    http.get(CHANNELS_URL).then(response => cb(response)).catch(trace => cb(trace.response))
  }
}



// WEBPACK FOOTER //
// ./src/api/client/ec-basic-field.js